
import { Component, Input, OnInit, OnChanges, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { NihlAnalayseService } from '../../../../services/nihl-analyse.service';
import { ClipboardService } from './clipboard.service';
import { ClaimsService } from 'src/app/services/claims.service';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import { IKCard, KCardFieldType } from 'ng-k-card';
import { KIconType } from 'ng-k-icon';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { KButtonType, KKcgButtonSubType } from 'ng-k-button';
import { BaseChartDirective } from "ng2-charts";
import { ChartComponent } from './chart/chart.component';
import { PageLeaveService } from 'src/app/services/page-leave.service';
import { NihlPageLeaveDataService } from 'src/app/services/nihl-page-leave-data.service';
import { SharedService } from 'src/app/services/shared.service';
import * as _ from  'lodash';

@Component({
  selector: 'app-audiogram-analyse',
  templateUrl: './audiogram-analyse.component.html',
  styleUrls: ['./audiogram-analyse.component.scss']
})
export class AudiogramAnalyseComponent implements OnInit {
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event): void {
    if (this.sharedService.getOnUserLogged()) {
      event.preventDefault();
      (event as any).returnValue = ''; // Required for some browsers
    }
  }
  testId: any;
  claimId: any;
  taskId: any;
  KButtonType = KButtonType;
  KKcgButtonSubType = KKcgButtonSubType;
  @Input() audioFreqIn: { [key: string]: any } = {}
  @Input() audiometryIn: { [key: string]: any } = {};
  @Input() instanceId?:number;
  presetFilters: { [key: string]: any } = {};
  ageCentile: { [key: string]: any } = {};
  claimInfo:any;
  claimInfo2 :any;
  lines:any = [];
  claimData:any = [];
  tdh39Amendment: boolean;
  rightEarData:any = null;
  sides: string[];
  airConductionSymmetryData:any = null;
  highFrequencyImpairmentData:any=null;
  noiseImmisionLevelData:any=null;
  notchEvaluationEarsData:any=null;
  bulgeEvaluationEarsData:any=null;
  leftEarData:any = null;
  includeLines = ["left", "right"];
  public successText!: string;
  public displaySuccess: boolean = false;
  public timeout!: number;
  public errorText: string = '';
  public displayError: boolean = false;
  public displayWarning: boolean = false;
  public warningText: string = '';
  public airCondSymmetries: IKCard[] = [];
  public highFrequencyImpairment: IKCard[] = [];
  public notchEvaluationLevel:  IKCard[] = [];
  public notchEvaluationEars: IKCard[] = [];
  public bulgeEvaluationEars: IKCard[] = [];
  public showWarningTextForNullAnchorPoints: boolean = true;

  public customData: any;

  config:any = {
    "left": {
      "reportType": "guideline",
      "calcJson": {
        "arhlParam": {
            "changeAgeTo": "",
            "changeCentileTo": "",
            "arhlParam": ""
        },
        "exposure": {
            "exposure": "",
            "newDbValue": ""
        },
        "anchor": {
            "changeAnchorPoints": "",
            "newLowerAnchor": "",
            "newUpperAnchor": ""
        }
      }
    },
    "right": {
      "reportType": "guideline",
      "calcJson":{
        "arhlParam": {
          "changeAgeTo": "",
          "changeCentileTo": "",
          "arhlParam": ""
        },
        "exposure": {
            "exposure": "",
            "newDbValue": ""
        },
        "anchor": {
            "changeAnchorPoints": "",
            "newLowerAnchor": "",
            "newUpperAnchor": ""
        }
      }
    }
  };
  filter: any = {};
 
  activeTab = 1;
 // audiometryIn: { [key: string]: any } = {};
  private unsubscribe$: Subject<any> = new Subject<any>();

  // Loader in table
  public loader:boolean = false;

  public plotFilter: any;
  public modifierFilter: any;
  public saveAudiogramParamsStatus = 'uptodate'

  @ViewChild(ChartComponent) chartComponent!: ChartComponent;
  
  constructor(
    private nihlAnalyseService: NihlAnalayseService,
    private claimsService:ClaimsService,
    private loaderService: GlobalLoadingService,
    private route: ActivatedRoute,
    private router:Router,
    private clipboardService: ClipboardService,
    private pageLeaveService: PageLeaveService,
    private nihlPageLeaveDataService: NihlPageLeaveDataService,
    private sharedService: SharedService
  ) {
  }

  ngOnChanges(){
   
  }
  ngAfterViewInit(){
   
  }

  public saveChartToImage() {
    let canvas = this.chartComponent.canvas.nativeElement;
    let nootes = this.getFootnotes();
    this.clipboardService.copyToClipboard(canvas, nootes).subscribe({
      next: (status) => {
        if(status) {
          this.successText = "Audiogram image downloaded";
          this.showMessage('success',2000);
          setTimeout(() => {
            this.displaySuccess = false;
          }, 2001);
        }
       
      }
    })
  }
  getFootnotes():string[] {
    let { left:leftAgeCentile, right:rightAgeCentile } = this.ageCentile;
    let { override } = this.setupRequestParams();
    let { left, right} = override;
    let footnote = [];
    const standardDict:any= {
      "guideline": "Guidelines",
      "iso2000": "ISO7029:2000",
      "iso2017": "ISO7029:2017"
    };
    if(this.plotFilter['mf2']['aahl_l']){
      footnote.push(`Left: ARHL Database ${standardDict[left.guideline]} ${leftAgeCentile.age} years old at ${leftAgeCentile.centile}th centile `)
    }
    if(this.plotFilter['mf2']['aahl_r']){
      footnote.push(`Right: ARHL Database ${standardDict[right.guideline]} ${rightAgeCentile.age} years old at ${rightAgeCentile.centile}th centile `)
    }
    if(this.plotFilter['mf2']['aahl_pts_l'] || this.plotFilter['mf2']['aahl_pts_r']){
      footnote.push(`ISO1999 expected NIPTS: ${left.yearsExposed} years exposed to noise of ${left.lepdLevel} dB(A) Lep'd`)
    }
    // if(this.plotFilter['mf2']['aahl_pts_r']){
    //   footnote.push(`ISO1999 expected NIPTS: ${right.yearsExposed} years exposed to noise of ${right.lepdLevel} dB(A) Lep'd`)
    // }
    return footnote;
  }

  public getClaimInfo(claimID: any) {
    //this.loaderService.startLoadingIndicator('getClaimInfo');
    this.claimInfo = {
      value: '',
      header: {
        label:moment(new Date(this.claimData.claimData.createdAt)).format('DD/MM/YYYY'),
        labelColour: 'brand-main',
        icon: {
          type: KIconType.fas,
          name: 'clock'
        }
      },
      clickable: false,
      fields: [
        {
          fieldType:  KCardFieldType.IdRef,
          label: 'Claim Reference',
          value: this.claimData?.claimDetails?.claimReference ? this.claimData?.claimDetails?.claimReference : ' ',
          icon: {
            type: KIconType.fas,
            name: 'tag',
            border: true
          }
        },
        {
          fieldType:  KCardFieldType.Text,
          label: 'Claimant Name',
          value: this.claimData.claimantDetails.claimantFirstName+' '+ this.claimData.claimantDetails.claimantLastName,
          icon: {
            type: KIconType.fas,
            name: 'user',
            border: true
          }
        },
        {
          fieldType:  KCardFieldType.Text,
          label: 'Condition',
          value: this.claimData.claimData.useCaseTitle,
          icon: {
            type: KIconType.fas,
            name: 'stethoscope',
            border: true
          }
        },
        {
          fieldType:  KCardFieldType.Link,
          label: 'Open >',
          value: '/claimForm/'+encodeURIComponent(this.claimId),
        }
      ]
    }
    let amountSymbol = ''

    this.claimInfo2 = {
      value: '',
      clickable: false,
      header: {
        label:moment(new Date(this.claimData.audiometry.audiogramDate)).format('DD/MM/YYYY'),
        labelColour: 'brand-main',
        icon: {
          type: KIconType.fas,
          name: 'clock'
        }
      },
      fields: [
        {
          fieldType:  KCardFieldType.Text,
          label: 'Type',
          value: this.claimData.audiometry.type,
          icon: {
            type: KIconType.fas,
            name: 'tag',
            border: true
          }
        },
        {
          fieldType:  KCardFieldType.Text,
          label: 'Audiologist',
          value: this.claimData.audiometry.audiologist? this.claimData?.audiometry?.audiologist : 'N/A',
          icon: {
            type: KIconType.fas,
            name: 'stethoscope',
            border: true
          }
        },    
        {
          fieldType:  KCardFieldType.Text,
          label: 'Age of the claimant when the test occurred',
          value: this.claimData.audiometry.claimantAgeTestOccurred? this.claimData?.audiometry?.claimantAgeTestOccurred  : 'N/A',
          icon: {
            type: KIconType.fas,
            name: 'calendar',
            border: true
          }
        },       
        // {
        //   fieldType:  KCardFieldType.Link,
        //   label: 'Medical Report Details >',
        //   value: '/nihl/investigation/edit-audiometry/'+encodeURIComponent(this.claimId)+'/'+encodeURIComponent(this.taskId)+'/'+this.testId,
        // }
      ]
    }
    //this.loaderService.stopLoadingIndicator('getClaimInfo');
  }
  public getWorkflowOverview() {
  const thisObj = this;
  const requestParam: any = {};
  requestParam.claimId = this.claimId || null;
  requestParam.testId = this.testId;
  this.loaderService.startLoadingIndicator('getWorkflowOverview');

  thisObj.nihlAnalyseService.getAudiogramMeta(requestParam).subscribe(result => {
    if (result.status === 'Success') {
      // // console.log('success')
      this.loaderService.stopLoadingIndicator('getWorkflowOverview');
      this.claimData = result.data;
      this.customData = {
        claimId : this.claimId,
        audiometryType: result.data.audiometry.type,
        claimantName : this.claimData.claimantDetails.claimantFirstName + this.claimData.claimantDetails.claimantLastName,
        medicalConditionLabel: 'NIHL',
        medicalConditionValue: 'nihl'
      }
      this.audiometryIn = result.data.audiometry;
      this.presetFilters = result.data.presetFilters?.amend_calculation ? result.data.presetFilters?.amend_calculation : {};
      this.plotFilter=result.data.presetFilters?.plot ? result.data.presetFilters?.plot : {};
      this.loadAudiogramParams(result.data.presetFilters.plot)
      this.getClaimInfo(this.claimId);
      
      if (this.presetFilters && Object.keys(this.presetFilters).length === 0) {
        this.loadAmendCalculationParams(false);
      } else {
        this.loadAmendCalculationParams(true, this.presetFilters);
        
      }
      this.getGuidelinesChartAndTable();

    }  
    
    if (result.status === 'Unprocessable') {
    }  
  },
  err => {
    // console.log('err')
    // console.log(err.error);
    if (err.error.status === 'Unprocessable') {
      this.loaderService.stopLoadingIndicator('getWorkflowOverview');
       this.claimData = [];
      this.errorText = err.error.Message;
      this.showMessage('error', 2000);
    }
  }); 
}

  async ngOnInit() {
    this.claimId = this.route.snapshot.paramMap.get('claimId');
    this.testId = this.route.snapshot.paramMap.get('testId');
    this.taskId = this.route.snapshot.paramMap.get('taskId');
    this.getAudiometryInput();
    this.getWorkflowOverview();
    this.setValueInService(this.saveAudiogramParamsStatus, 'audiogram-analyse');
    // this.loadAudiogramParams();
  }

  
  getAudiometryInput() {
   
  }

  loadAmendCalculationParams(presetFiltersPresent: boolean, amendConfig?:any) {
    if(presetFiltersPresent) {
      this.config = amendConfig;
    } else {
      this.config = {
        "left": {
          "reportType": "guideline",
          "calcJson": {
            "arhlParam": {
                "changeAgeTo": this.ageCentile? this.ageCentile?.['left']?.age : '75',
                "changeCentileTo": this.ageCentile? this.ageCentile?.['left']?.centile  : '75',
                "arhlParam": "1"
            },
            "exposure": {
                "exposure": "1",
                "newDbValue": this.audiometryIn['notionalExposure']
            },
            "anchor": {
                "changeAnchorPoints": "",
                "newLowerAnchor": "",
                "newUpperAnchor": ""
            }
          }
        },
        "right": {
          "reportType": "guideline",
          "calcJson":{
            "arhlParam": {
              "changeAgeTo": this.ageCentile?  this.ageCentile?.['right']?.age : '75',
              "changeCentileTo": this.ageCentile?  this.ageCentile?.['right']?.centile : '75',
              "arhlParam": "1"
            },
            "exposure": {
                "exposure": "1",
                "newDbValue":this.audiometryIn['notionalExposure']
            },
            "anchor": {
                "changeAnchorPoints": "",
                "newLowerAnchor": "",
                "newUpperAnchor": ""
            }
          }
        }
      }
    }
   
  }

  loadAudiogramParams(plotFilters?: any) {
    
    

    if (plotFilters) {
      this.plotFilter = plotFilters;
    } else {
      this.plotFilter = {
        "htl": {
            "left": true,
            "right": true
        },
        "mf2": {
            "left": true,
            "right": true,
            "aahl_l": true,
            "aahl_pts_l": false,
            "aahl_r": true,
            "aahl_pts_r": false
        },
        "lcb": {
            "left": false,
            "right": false
        }
      }
    }
    
  }

  saveAudiogramParams() {
    this.plotFilter = this.filter ? this.filter : {};
    this.modifierFilter = this.config ? this.config : {};
    if (this.modifierFilter.left.calcJson.exposure?.yearsExposedToNoise > 49 || this.modifierFilter.right.calcJson.exposure?.yearsExposedToNoise > 49 ||
      this.modifierFilter.left.calcJson.exposure?.yearsExposedToNoise < 1  || this.modifierFilter.right.calcJson.exposure?.yearsExposedToNoise < 1 
    ) {
      this.errorText = "Years exposed to noise should be between 1 and 49.";
      this.showMessage('error', 2000);
      setTimeout(() => {
        this.displayError = false;
      }, 2001);
      return;
    } else {
      const thisObj = this;
      const requestParam: any = {};
      requestParam.claimId = this.claimId || null;
      requestParam.taskId = this.taskId;
      requestParam.actionName = 'add_audiometry_preset_filters';
      requestParam.payload = {
        "testId": this.testId,
        "plot": this.plotFilter,
        "amend_calculation": this.modifierFilter
      };
      // this.loaderService.startLoadingIndicator('saveAudiogramParams');
    
    thisObj.nihlAnalyseService.add_audiometry_preset_filters(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('saveAudiogramParams');
        if(result.data.isValid) {
          this.successText = "Configuration saved successfully";
          this.saveAudiogramParamsStatus = 'uptodate';
          this.setValueInService(this.saveAudiogramParamsStatus, 'audiogram-analyse');
          this.showMessage('success',2000);
          setTimeout(() => {
            this.displaySuccess = false;
            this.presetFilters = this.modifierFilter
          }, 2001);
        }
      }  
      if (result.status === 'Unprocessable') {
      }  
    },
    err => {
      // console.log('err')
      // console.log(err.error);
      if (err.error.status === 'Unprocessable') {
        // this.loaderService.stopLoadingIndicator('saveAudiogramParams');
        this.errorText = err.error.Message;
        this.showMessage('error', 2000);
      }
    }); 
    }    
    

  }

  onNavChange(event: any) {
  
  }

  async gotoAudiometryForm(){
    if (this.saveAudiogramParamsStatus === 'modified') {
      // await this.confirmSaveAudiogramParams();
      this.router.navigate(["nihl/investigation/edit-audiometry/", this.claimId, this.taskId, this.testId]);
    } else {
      this.router.navigate(["nihl/investigation/edit-audiometry/", this.claimId, this.taskId, this.testId]);
    }
  }
  ngOnDestroy() {
    this.unsubscribe$.complete();
  }

  public showMessage(msgType: any, timeout: any) {
    this.displaySuccess = false;
    if ( msgType === 'success' ) {
      this.displaySuccess = true;
    }
    if ( msgType === 'error') {
      this.displayError = true;
    }
    if ( msgType === 'warning') {
      this.displayWarning = true;
    }
    if ( timeout ) {
      this.timeout = timeout;
    }
  }

 setupRequestParams () :any {
  let {left, right} = this.config;
  // console.log(this.audiometryIn['rightEar'])
  const lowerAnchor = this.audiometryIn['rightEar']["500hz"];
  // console.log(lowerAnchor)

  const lowerAnchorRightKey = `${right?.calcJson?.anchor?.newLowerAnchor}hz`; // Replace '500' and add 'hz'
  const lowerAnchorRightValue = this.audiometryIn['rightEar'][lowerAnchorRightKey];
  // console.log(lowerAnchorRightValue)

  const upperAnchorRightKey = `${right?.calcJson?.anchor?.newUpperAnchor}hz`; // Replace '500' and add 'hz'
  const upperAnchorRightValue = this.audiometryIn['rightEar'][upperAnchorRightKey];
  // console.log(upperAnchorRightValue)

  const upperAnchorLeftKey = `${left?.calcJson?.anchor?.newUpperAnchor}hz`; // Replace '500' and add 'hz'
  const upperAnchorLeftValue = this.audiometryIn['leftEar'][upperAnchorLeftKey];
  // console.log(upperAnchorLeftValue)  

  const lowerAnchorLeftKey = `${left?.calcJson?.anchor?.newLowerAnchor}hz`; // Replace '500' and add 'hz'
  const lowerAnchorLeftValue = this.audiometryIn['leftEar'][lowerAnchorLeftKey];
  // console.log(lowerAnchorLeftValue)  

  let guideline =  right?.reportType.toLowerCase() || left?.reportType.toLowerCase() || 'guideline';
  let lepdLevel =  right?.calcJson?.exposure?.newDbValue || left?.calcJson?.exposure?.newDbValue || this.audiometryIn['notionalExposure'];
  let yearsExposed = right?.calcJson?.exposure?.yearsExposedToNoise || left?.calcJson?.exposure?.yearsExposedToNoise || this.audiometryIn['yearsExposedToNoise'];
  
  if(this.showWarningTextForNullAnchorPoints) {
    if (upperAnchorLeftValue == '' || upperAnchorLeftValue == '' || lowerAnchorLeftValue == '' || lowerAnchorRightValue == '') {
      this.warningText = "Default anchor points used for calculation. The modified anchor point selected is null";
      this.showWarningTextForNullAnchorPoints = false;
      this.showMessage('warning', 1000);
      setTimeout(() => {
        this.displayWarning = false;
      }, 1005);
    }
  }
    
  let leftConfig = {
    "guideline": guideline,
    "age": left?.calcJson?.arhlParam?.changeAgeTo || this.ageCentile['age'],
    "centile": left?.calcJson?.arhlParam?.changeCentileTo || this.ageCentile['centile'],
    "lowerAnchor": lowerAnchorLeftValue == '' ? undefined : left?.calcJson?.anchor?.newLowerAnchor || 0,
    "upperAnchor": upperAnchorLeftValue == '' ? undefined : left?.calcJson?.anchor?.newUpperAnchor || 0,
    "lepdLevel": lepdLevel,
    "yearsExposed": yearsExposed,
    "arhlParamsMode": left?.calcJson?.arhlParam?.arhlParam || 1
  }

  let rightConfig = {
    "guideline": guideline,
    "age": right?.calcJson?.arhlParam?.changeAgeTo || this.ageCentile['age'],
    "centile": right?.calcJson?.arhlParam?.changeCentileTo || this.ageCentile['centile'] ,
    "lowerAnchor": lowerAnchorRightValue == '' ? undefined : right?.calcJson?.anchor?.newLowerAnchor || 0,
    "upperAnchor": upperAnchorRightValue == '' ? undefined : right?.calcJson?.anchor?.newUpperAnchor || 0,
    "lepdLevel": lepdLevel,
    "yearsExposed": yearsExposed,
    "arhlParamsMode": right?.calcJson?.arhlParam?.arhlParam || 1
  };
   return  {
    "claimId" : this.claimId,
    "testId" : this.testId,
    "mf2": "Include",
    "lepdLevel": lepdLevel,
    "override": {
      "left": leftConfig,
      "right":rightConfig
    }
  }
}

  getGuidelinesChartAndTable() {
    let reqParam = this.setupRequestParams();
    this.loader = true;
    this.nihlAnalyseService.calculate(reqParam).subscribe((res)=> {
      let { data} = res;
      this.tdh39Amendment = data.tdh39Amendment;
      if(data){
        if(data.left){
          this.leftEarData = data.left
        }
        if(data.right){
           this.rightEarData = data.right
        }

        if(data.airConductionSymmetry) {
          this.airCondSymmetries = [];
          this.airConductionSymmetryData = data.airConductionSymmetry;
          for (const symmData of this.airConductionSymmetryData) {
            this.addAirCondSym(symmData.frequency, 'Discrepancy', 'Discrepancy', symmData.value);
          }
        }
        if (data.highFrequencyImpairment) {
          this.highFrequencyImpairment = [];
          this.highFrequencyImpairmentData = data.highFrequencyImpairment;
          this.sides = ['right', 'left'];
          this.sides.forEach((side: string) => {
            this.addHighFrequencyImp(this.highFrequencyImpairmentData[`${side}`]);
          });
        }
        
        if (data.noiseImmisionLevel) {
          this.notchEvaluationLevel=[]
          this.noiseImmisionLevelData = data.noiseImmisionLevel;
          for(let noiseData of this.noiseImmisionLevelData){
            if (noiseData.key === 'Noise Immission Level') {
              this.addNoiseImmisionLevel(noiseData)
            }
          }
        }
       
        if (data.notchValues) {
          this.notchEvaluationEars = [];
          this.notchEvaluationEarsData = data.notchValues;
          this.sides = ['right', 'left'];
          this.sides.forEach((side: string) => {
            this.addNotchEvaluation(this.notchEvaluationEarsData[`${side}`]);
          });
        }

        if (data.bulgeAdvice) {
          this.bulgeEvaluationEars = [];
          this.bulgeEvaluationEarsData = data.bulgeAdvice;
          this.sides = ['right', 'left'];
          this.sides.forEach((side: string) => {
            this.addBulgeAdvice(this.bulgeEvaluationEarsData[`${side}`]);
          });
        }

        
       
        let isEmptyAgeCentileOnInstance = !this.ageCentile || Object.keys(this.ageCentile).length == 0;
        if (data.paramsUsed) {
          this.ageCentile = data.paramsUsed;
          if(isEmptyAgeCentileOnInstance) {
              this.loadAmendCalculationParams(false);
          }
          if(!this.isValidConfig()) {
            this.fixMissingValuesINConfig();
          }
        }
        this.loader = false;
        this.reshapeDataset(); 
      }
    });
  }

   // Method to dynamically add cards
   public addAirCondSym(value: string, discrepancyLabel: string, discrepancyValue: string, idRefValue: any): void {
    const newAirCondSymm: IKCard = {
      value: 'Lack of symmetry at '+value +', '+ idRefValue + 'dB △',
      cardClass: 'airConductionSymmetry',
      clickable: false,
      cornerIndicatorColour: (idRefValue > 10) ? 'amber' : '',
      fields: [
        {
          fieldType: KCardFieldType.Text,
          label: discrepancyLabel,
          value: discrepancyValue,
        },
        {
          fieldType: KCardFieldType.IdRef,
          label: discrepancyLabel,
          value: idRefValue + ' dB (A)',
        },
      ],
    };

    this.airCondSymmetries.push(newAirCondSymm);  // Add the new card to the array
  }

  public addHighFrequencyImp(earData: any): void {
    const newHighFreqImp: IKCard = {
      value: earData.message,
      cardClass: 'highFreqImp',
      clickable: false,
      cornerIndicatorColour: (earData.highFrequencyImpairmentFound) ? 'brand-main' : 'amber',
      fields: [
        {
          fieldType: KCardFieldType.Text,
          label: earData.ear,
          value: earData.ear,
        },
        {
          fieldType: KCardFieldType.IdRef,
          label: earData.frequency,
          value: (earData.frequency ? earData.frequency + ' ' : ' - ') + earData.unit,
        },
      ],
    };

    this.highFrequencyImpairment.push(newHighFreqImp);  // Add the new card to the array
}

public addNoiseImmisionLevel(noiseData:any): void {
  const newNoiseImm: IKCard = {
    value:noiseData.text,
    cardClass: 'noiseImmision',
    clickable: false,
    cornerIndicatorColour: '', 
    fields: [
      {
        fieldType: KCardFieldType.Text,
        label: noiseData.key,
        value:noiseData.key
      },
      {
        fieldType: KCardFieldType.IdRef,
        label:noiseData.key,
        value: noiseData.value +' dB (A)',
      },
    ],
  };

  this. notchEvaluationLevel.push(newNoiseImm);  // Add the new card to the array
}

public checkCornerIndicator(indicatorType: any | undefined) {
  let color = "black";
  if (indicatorType == 'error') {
    return 'red';
  } else 
  if (indicatorType == 'warning') {
    return 'amber';
  } else 
  if (indicatorType == 'success') {
    return 'brand-main';
  }
  return ''
}

public addNotchEvaluation(notchData: any): void {
  const newNotchValues: IKCard = {
    value: notchData.text,
    cardClass: 'notchValues',
    clickable: false,
    cornerIndicatorColour: this.checkCornerIndicator(notchData.type)  ,
    fields: [
      {
        fieldType: KCardFieldType.Text,
        label:notchData.ear,
        value: `Notch - ${notchData.ear}`,
      },
      {
        fieldType: KCardFieldType.IdRef,
        label: notchData.highestFrequency,
        value: notchData.highestFrequency,
      },
    ],
  };

  this.notchEvaluationEars.push(newNotchValues);  // Add the new card to the array
}



public addBulgeAdvice(bulgeData: any): void {
  const newBulgeValues: IKCard = {
    value: bulgeData.text,
    cardClass: 'bulgeValues',
    clickable: false,
    cornerIndicatorColour: this.checkCornerIndicator(bulgeData.type),
    fields: [
      {
        fieldType: KCardFieldType.Text,
        label:bulgeData.key + bulgeData.ear,
        value: `${bulgeData.key} - ${bulgeData.ear}`,
      },
      {
        fieldType: KCardFieldType.IdRef,
        label: bulgeData.value,
        value: `${bulgeData.value} ${bulgeData.unit}`,
      },
    ],
  };

  this.bulgeEvaluationEars.push(newBulgeValues);  // Add the new card to the array
}


  fixMissingValuesINConfig() {
    let arhlParamLeft = {
              "changeAgeTo": this.ageCentile?  this.ageCentile?.['left']?.age : '75',
              "changeCentileTo": this.ageCentile?  this.ageCentile?.['left']?.centile : '75',
              "arhlParam": "1"
   }

   let arhlParamRight = {
              "changeAgeTo": this.ageCentile?  this.ageCentile?.['right']?.age : '75',
              "changeCentileTo": this.ageCentile?  this.ageCentile?.['right']?.centile : '75',
              "arhlParam": "1"
    }

    if(this.config.right.calcJson.arhlParam) {
      this.config.right.calcJson.arhlParam = {
        ...arhlParamRight,
        ...this.config.right.calcJson.arhlParam
      }
    } else {
      this.config.right.calcJson.arhlParam = arhlParamRight;
    }

    if(this.config.left.calcJson.arhlParam) {
      this.config.right.calcJson.arhlParam = {
        ...arhlParamLeft,
        ...this.config.left.calcJson.arhlParam
      }
    } else {
      this.config.left.calcJson.arhlParam = arhlParamLeft;
    }
    
  }

  isValidConfig() {
    let { left, right} = this.config;
    let arhlLeft = left.calcJson.arhlParam;
    let arhlRight = right.calcJson.arhlParam;
    let response = true;
    if(!arhlLeft.changeAgeTo || !arhlLeft.changeCentileTo )  {
      response = false;
    } 
    if(!arhlRight.changeAgeTo || !arhlRight.changeCentileTo )  {
      response = false;
    }
    return response;
  }

  setValueInService(value: any, currentPage: any): void {
    const valueToSet = value;
    const currPage = currentPage;
    this.nihlPageLeaveDataService.setValue(value,currPage);
  }

  setSaveAudiogramParamsInService() {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId || null;
    requestParam.taskId = this.taskId;
    requestParam.actionName = 'add_audiometry_preset_filters';
    requestParam.payload = {
      "testId": this.testId,
      "plot": this.plotFilter,
      "amend_calculation": this.config
    };
    this.nihlPageLeaveDataService.sendParams(requestParam);
  }

  modifierUpdated($event:any) {
     this.saveAudiogramParamsStatus = 'modified';
    this.setValueInService(this.saveAudiogramParamsStatus, 'audiogram-analyse');
    this.config =_.merge(this.config, $event);
    this.setSaveAudiogramParamsInService();
    this.getGuidelinesChartAndTable();
  }

  filterChange($event:any){
    this.saveAudiogramParamsStatus = 'modified';
    this.setValueInService(this.saveAudiogramParamsStatus, 'audiogram-analyse');
    this.filter = $event;
    this.plotFilter = this.filter;
    this.setSaveAudiogramParamsInService();
    this.getGuidelinesChartAndTable();
  }

  async goToPage() {
    if (this.saveAudiogramParamsStatus === 'modified') {
      // await this.confirmSaveAudiogramParams();
      this.router.navigate(['/claimDetail/',this.claimId]);
    } else {
      this.router.navigate(['/claimDetail/',this.claimId]);
    }
  }

  async confirmSaveAudiogramParams() {
    let text = "Do you want to save the audiogram params before exiting the page?";
      if (confirm(text) == true) {
        text = "You pressed OK!";
        this.saveAudiogramParams();
      } else {
        text = "You canceled!";
      }
  }

  reshapeDataset():any{
    if(!this.leftEarData || !this.rightEarData){
      return false
    }
  let lineitems = [];
  if (this.plotFilter) {
    this.filter = this.plotFilter;
  } else {
    this.filter = {
      "htl": {
          "left": false,
          "right": false
      },
      "mf2": {
          "left": false,
          "right": false,
          "aahl_l": false,
          "aahl_pts_l": false,
          "aahl_r": false,
          "aahl_pts_r": false
      },
      "lcb": {
          "left": false,
          "right": false
      }
    };
  }
  // console.log(this.filter)
  if(this.filter.htl.left){
      lineitems.push( {
        profile:"left",
        label:"Left Ear - HTL",
        data:this.leftEarData?.chart?.arhl?.data[0]
      });
  }

  if(this.filter.htl.right){
    lineitems.push({
      profile:"right",
      label:"Right Ear - HTL",
      data:this.rightEarData?.chart?.arhl?.data[0]
    });
  }

  if(this.filter.mf2.left){
    // console.log('yes mf2 left')
    if(this.filter.mf2.aahl_l){
      lineitems.push({
        profile:"mf2-left-aahl",
        label:"Left Ear - ARHL",
        data:this.leftEarData?.chart?.arhl?.data[1]
      });
    }

    if(this.filter.mf2.aahl_pts_l){
      lineitems.push({
        profile:"mf2-left-aahl-pts",
        label:"Left Ear - ISO1999 ARHL+NIPTS",
        data:this.leftEarData?.chart?.arhl?.data[2]
      });
    }
  }
  if(this.filter.mf2.right){
    // console.log('yes mf2 right')
      if(this.filter.mf2.aahl_r){
        lineitems.push({
          profile:"mf2-right-aahl",
          label:"Right Ear - ARHL",
          data:this.rightEarData?.chart?.arhl?.data[1]
        });
    }
    if(this.filter.mf2.aahl_pts_r){
      lineitems.push({
        profile:"mf2-right-aahl-pts",
        label:"Right Ear - ISO1999 ARHL+NIPTS",
        data:this.rightEarData?.chart?.arhl?.data[2]
      });
    }

  }
   this.lines =lineitems;
  }



}
